import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import autogasMeterReport from "./autogas-meter-report.json";
import base from "./base.json";
import documents from "./documents.json";
import gasContainers from "./gas-containers.json";
import checkout from "./checkout.json";
import meterReport from "./meter-report.json";
import monthlyPayment from "./monthly-payment.json";
import orders from "./orders.json";
import priceCockpit from "./price-cockpit.json";
import shared from "./shared.json";
import start from "./start.json";
import westfalengasBio from "./westfalengas-bio.json";

const fbsHub = {
  ...getI18nJsonProp(autogasMeterReport, "fbsHub"),
  ...getI18nJsonProp(base, "fbsHub"),
  ...getI18nJsonProp(checkout, "fbsHub"),
  ...getI18nJsonProp(documents, "fbsHub"),
  ...getI18nJsonProp(gasContainers, "fbsHub"),
  ...getI18nJsonProp(meterReport, "fbsHub"),
  ...getI18nJsonProp(monthlyPayment, "fbsHub"),
  ...getI18nJsonProp(orders, "fbsHub"),
  ...getI18nJsonProp(priceCockpit, "fbsHub"),
  ...getI18nJsonProp(shared, "fbsHub"),
  ...getI18nJsonProp(start, "fbsHub"),
  ...getI18nJsonProp(westfalengasBio, "fbsHub"),
};

export default fbsHub;
